import CountryLanding from "@/components/country/CountryLanding";
import { ARGENTINA } from "@/data/countryPages";

export default function EOSArgentina() {
  return <CountryLanding country={ARGENTINA} />;
}
